// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Maximum number of retries for the throttling retry policy
 */
export const DEFAULT_CLIENT_MAX_RETRY_COUNT = 3;
